<form #quitForm="ngForm" (ngSubmit)="quit(quitForm)" *ngIf="technicalAlertProvider.activeAlertData.inProgress">

    <ion-list-header>Quittierung</ion-list-header>
    <ion-item>
        <ion-label position="stacked">Quittierungsgrund</ion-label>
        <ion-select [(ngModel)]="formdata.reason" name="reason" required>
            <ion-select-option *ngFor="let reason of reasons"
                               value="{{reason.key}}">{{reason.value}}</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-list-header>Kommentar</ion-list-header>
    <ion-item>
        <ion-label position="stacked">Bemerkung</ion-label>
        <ion-textarea [(ngModel)]="formdata.comment" name="comment"></ion-textarea>
    </ion-item>
    <ion-item>
        <ion-button class="full-width" [disabled]="!quitForm.form.valid" expand="block" color="danger" size="large" type="submit">Alarm quittieren
        </ion-button>
    </ion-item>

</form>
<ion-text>
    <h1 *ngIf="!technicalAlertProvider.activeAlertData.inProgress" class="ion-text-center ion-text-uppercase">kein Alarm offen</h1>
</ion-text>
